export default __webpack_public_path__ + "static/media/tool.afafffb5.jpg";